import { h, Component } from "preact";
import { connect } from "react-redux";
import { reduxForm, Field } from "redux-form";
import InputField from "./fields/InputField";
import { addDiscount, removeDiscount } from "../state/actions/orderActions";
import ActionButton from "./ActionButton";
import crossIcon from "../assets/images/icon-cross.svg";
import successIcon from "../assets/images/icon-success.svg";

class DiscountCode extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  componentDidMount() {
    const { initialCode, addDiscount, order, event } = this.props;
    if (initialCode) {
      // addDiscount(event.data._id, order.data._id, initialCode);
    }
  }

  save = values => {
    const { addDiscount, order, event } = this.props;
    const code = values.discountCode;
    if (code) {
      addDiscount(event.data._id, order.data._id, values.discountCode);
    }
  };

  remove = () => {
    const { removeDiscount, order } = this.props;
    removeDiscount(order.data._id);
  };

  render() {
    const {
      event,
      order,
      allowAdd = false,
      ticketSelection,
      handleSubmit,
      initialCode
    } = this.props;
    const discountCodeStyle = {
      background: `url(${successIcon}) no-repeat left 5px center`,
      backgroundSize: 20,
      color: "#157e77",
      margin: "0",
      padding: "4px 0 4px 28px",
      display: "inline-block",
      fontWeight: 600
    };
    const removeStyle = {
      background: `url(${crossIcon}) no-repeat right 5px center`,
      backgroundSize: 20,
      paddingLeft: 30,
      cursor: "pointer",
      float: "right",
      height: 30
    };
    const discountStyle = {
      paddingTop: 12,
      paddingBottom: 12,
      marginBottom: 24,
      borderBottom: "1px solid #dedede"
    };
    let discountDisplay = false;
    const ticketsWithCodes =
      order.data && order.data.tickets
        ? order.data.tickets.filter(t => {
            // only show discount codes not auto discounts
            const codeDiscounts = t.discountCodes
              ? t.discountCodes.filter(d => d.type !== "auto")
              : [];
            if (codeDiscounts.length) {
              return true;
            }
            return false;
          })
        : false;
    const ticketWithCodes =
      ticketsWithCodes && ticketsWithCodes.length ? ticketsWithCodes[0] : false;
    const discountCode = ticketWithCodes
      ? ticketWithCodes.discountCodes.filter(d => d.type !== "auto")[0]
      : false;
    if (allowAdd && discountCode) {
      discountDisplay = (
        <span>
          Discount code:{" "}
          <span style={discountCodeStyle}>{discountCode.code}</span>
          <a onClick={this.remove} style={removeStyle} />
        </span>
      );
    }

    if (!allowAdd && discountCode) {
      discountDisplay = <span>Discount code: {discountCode.code}</span>;
    }

    if (discountDisplay) {
      return <div style={discountStyle}>{discountDisplay}</div>;
    }

    return allowAdd && event && event.data && event.data.hasDiscounts ? (
      <div style={discountStyle}>
        <form onSubmit={handleSubmit(this.save)}>
          <div style={{ display: "flex" }}>
            <Field
              style={{
                width: "80%"
              }}
              inputStyle={{
                borderRadius: "4px 0 0 4px"
              }}
              type="text"
              name="discountCode"
              label="Enter discount code"
              component={InputField}
              placeholder="Discount Code"
            />
            <ActionButton
              loading={order.addDiscountRequest.loading}
              classNames="btn-secondary"
              dataCY="DiscountCodeApply"
              style={{
                borderRadius: "0 4px 4px 0",
                padding: "4px 10px",
                marginTop: 24,
                minWidth: 90
              }}
            >
              Apply
            </ActionButton>
          </div>
          {order.addDiscountRequest.error ? (
            <p class="text-error error-icon">
              {order.addDiscountRequest.error}
            </p>
          ) : (
            ""
          )}
        </form>
      </div>
    ) : (
      ""
    );
  }
}

DiscountCode = reduxForm({
  form: "discountCode"
})(DiscountCode);

export default connect(
  (state, ownProps) => ({
    event: state.event,
    order: state.order
  }),
  { addDiscount, removeDiscount }
)(DiscountCode);



// WEBPACK FOOTER //
// ./components/DiscountCode.js